var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-form',[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":"Content","label-for":"bio-area"}},[_c('h5',[_vm._v("Lease NFTs in your wallet.")])])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }